import React from 'react';
import styles from './profile.module.css'
import { useMediaQuery, Flex, Box} from '@chakra-ui/react'
const Profile = () => {
  const  [notSmallScreen] = useMediaQuery('(min-width: 600px)');

  
    return (
      <div id='profile_section'>
         <h1 className={styles.heading}>About</h1>
    <Flex direction={notSmallScreen ? "row" : "column"} w="100%" 
    maxWidth={{base: "100vh", md: "130vh",lg:"130vh", xl: "130vh"}}>
        {/* box for 7+ year */}
       
        <Box fontSize={20}> Hello stranger! 👋, my name is Ratnesh Pandey and I am a Full Stack Web Developer (MERN Stack), passionate about building digital products that improve everyday experience for people.

I love to work on exciting projects that test what I've learnt, whilst being exposed to the power and potential of the ever-evolving technologies around us. I'm always looking for better, and more importantly, ethical and accessible ways to solve the common problems we are faced with day-to-day.
</Box>

</Flex>
   <Box fontSize={20}>
   Drop a mail @  <strong>pandeyratnesh1997@gmail.com</strong>
  
   </Box>
   <Box fontSize={20}>
   Call me @ <strong> 7278053703</strong> 
   </Box>

    </div>
  )
}

export default Profile